module.exports = __webpack_public_path__ + "img/35.fc0568e4.png";